import { GTMEvent } from '../GTM'
import { isValidProductsDetails } from './pushPlp'
import { GTMProductData } from './pushPdp'

type GTMSearchEvent = GTMEvent & {
    'search query': string
    'search results': number
    ecommerce?: {
        currencyCode: string
        impressions: GTMProductData[]
    }
}

export const pushSearch = (data: Record<string, unknown>): GTMEvent => {
    const { searchTerm, currencyCode, totalCount, productsDetails } = data

    if (!searchTerm) {
        console.info('Invalid GTM search data')
        return { event: '' }
    }

    const impressions = isValidProductsDetails(productsDetails)
        ? productsDetails
        : []

    const processedData: GTMSearchEvent = {
        event: 'search',
        'search query': String(searchTerm),
        'search results': Number(totalCount) || impressions?.length,
        _clear: true
    }

    if (isValidProductsDetails(productsDetails) && impressions.length > 0) {
        processedData['ecommerce'] = {
            currencyCode: String(currencyCode),
            impressions: productsDetails
        }
    }

    return processedData
}
